import React, { useState } from 'react';
import { MDBDataTable } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { TableActionItems } from '../datatable/TableActionItems';
import { formatBackendDateEtLocale } from '../../util/dateUtil';
import useDebouncedValue from '../../util/useDebouncedValue';
import '../../style/DataTable.css';

const GENDER_LABEL = { MALE: 'Mees', FEMALE: 'Naine' };

// Rows arrive from the backend already ordered KEEGLIVEEB-first, then missing-gender-first,
// then by name. Only the Allikas header is clickable (every other column is sort: 'disabled'),
// so that incoming order survives until an admin deliberately flips the source direction.
const PlayersDataTable = (props) => {
  // Debounced client-side search: filtering the full player list on every keystroke is what made
  // the search laggy, so we debounce the term and disable MDBDataTable's own synchronous search.
  const [search, setSearch] = useState('');
  const q = useDebouncedValue(search, 300).trim().toLowerCase();
  const players = q
    ? (props.players || []).filter((p) =>
        `${p.firstName || ''} ${p.lastName || ''} ${p.clubName || ''} ${p.source || ''}`
          .toLowerCase()
          .includes(q)
      )
    : props.players || [];

  const getData = () => {
    let rowData = [];
    players.map((p) => {
      const missing = !p.gender;
      return rowData.push({
        fullName: `${p.firstName || ''} ${p.lastName || ''}`.trim() || 'N/A',
        dateOfBirth: Array.isArray(p.dateOfBirth)
          ? formatBackendDateEtLocale(p.dateOfBirth)
          : '-',
        clubName: p.clubName || '-',
        gender: missing ? (
          <span className="gender-missing text-danger">
            <FontAwesomeIcon icon={faExclamationTriangle} /> Määramata
            <span className="gender-missing-tip">
              Sugu on määramata — palun määra selle mängija sugu.
            </span>
          </span>
        ) : (
          GENDER_LABEL[p.gender] || p.gender
        ),
        // A null source predates the source column and means KEEGLIVEEB; showing it as such
        // keeps such a row inside the KEEGLIVEEB block when the Allikas header is clicked.
        source: p.source || 'KEEGLIVEEB',
        actions: <TableActionItems editAction={() => props.editAction(p.id)} />,
      });
    });
    if (!rowData.length) {
      return null;
    }
    return {
      columns: [
        { label: 'Nimi', field: 'fullName', sort: 'disabled' },
        { label: 'Sünniaeg', field: 'dateOfBirth', sort: 'disabled' },
        { label: 'Klubi', field: 'clubName', sort: 'disabled' },
        { label: 'Sugu', field: 'gender', sort: 'disabled' },
        // Seeded 'asc' so the first click sorts KEEGLIVEEB first and the next one flips it.
        { label: 'Allikas', field: 'source', sort: 'asc' },
        { label: '', field: 'actions', sort: 'disabled' },
      ],
      rows: rowData,
    };
  };
  const tableData = getData();

  return (
    <div>
      <input
        type='text'
        className='form-control mb-2'
        style={{ maxWidth: '320px' }}
        placeholder='Otsi'
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={25}
          bordered={false}
          paging
          searching={false}
          sortable
        />
      ) : (
        <div style={{ marginTop: '25px' }}>
          {q ? 'Tulemusi ei leitud' : 'Info puudub'}
        </div>
      )}
    </div>
  );
};

export default PlayersDataTable;
